import { fallback } from '@tanstack/router-zod-adapter';
import { z } from 'zod';

export const VesselSearchSchema = z.object({
    tab: fallback(z.enum(['overview', 'schedule', 'orders', 'products', 'contracts']), 'overview').default('overview'),
});
